import client from '@common/utils/rest';

const URL_PREFIX = 'api/dbSecurity';

export const getConfig = () => {
  return client({
    path: URL_PREFIX,
    method: 'GET',
  }).then((response) => {
    return response.entity;
  });
};

export const getDuplicatedPedigrees = () => {
  return client({
    path: `${URL_PREFIX}/duplicatePedigrees`,
    method: 'GET',
  }).then((response) => {
    return response.entity;
  });
};

export const getDuplicatedIndividuals = () => {
  return client({
    path: `${URL_PREFIX}/duplicateIndividuals`,
    method: 'GET',
  }).then((response) => {
    return response.entity;
  });
};

export const updateConfig = (data) => {
  return client({
    path: URL_PREFIX,
    method: 'POST',
    entity: data,
  });
};